import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useEffect, useMemo } from 'react';
import { Helmet } from 'react-helmet';
import { ContactConsultationCompleteView } from '@/components/pages/contact/consultation/ContactConsultationCompleteView/ContactConsultationCompleteView';
import Layout from '@/container/Layout';
import Breadcrumb from '@/container/Layout/Breadcrumb';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { contactPath, contactConsultationCompletePath, getAbsolutePath, } from '@/utils/router/links';
const title = 'コンサル選定のご相談 - 完了｜PROFFIT';
const description = 'コンサル選定に向けてヒアリングを実施し、活用のアドバイスをしながら、依頼事項を明確に整理します。';
/**
 * コンサル選定のご相談の完了ページ
 */
export const ContactConsultationCompletePage = (props) => {
    const { resetFormState } = props;
    /** パンくず */
    const breadcrumbs = useMemo(() => [
        { link: contactPath(), text: 'お問い合わせ' },
        { text: 'コンサル選定のご相談' },
    ], []);
    useEffect(() => {
        resetFormState();
    }, [resetFormState]);
    return (_jsxs(Layout, Object.assign({ mainClassName: clsx('l-main') }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(contactConsultationCompletePath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(Breadcrumb, { lists: breadcrumbs }), _jsx(ContactConsultationCompleteView, { className: clsx('mb-80') })] })));
};
